import { Routes, Route, useSearchParams } from "react-router-dom"
import { Home } from './client/routes/home';
import { Leaderboard } from "./client/routes/leaderboard";
import { Player } from "./client/routes/player";
import { Meta } from "./client/routes/meta";
import { Heroes } from "./client/routes/heroes";
import { Hero } from "./client/routes/hero";
import { SubscribeGlobalState } from "./common/hooks/global-state";
import { Updates } from "./client/routes/updates";
import { Update } from "./client/routes/update";
import { PlayersSearch } from "./client/routes/players-search";
import { EditMediaPopup } from "./client/components/popups/edit-media-popup";
import { PresentPopup } from "./client/components/popups/presents-popup";
import { BuyDotaPlusPopup, BuyShardsPopup, PaymentFunPayPopup, PaymentMethodPopup, PaymentPatreonPopup } from "./client/components/popups/payments-popup";
import { MatchPage } from "./client/routes/match";
import { MatchesSearch } from "./client/routes/matches-search";
import { useRef, useState } from "react";
import { NavMobileMenu } from "./client/components/layout/header";

export const Index = () => {
  const _ = SubscribeGlobalState('language')
  const [searchParams, setSearchParams] = useSearchParams()
  const popup = searchParams.get("popup") as PopupType
  
  return <>
    <div>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/players/search" element={<PlayersSearch />} />
        <Route path="/players/:id" element={<Player />} />
        <Route path="/heroes/meta" element={<Meta />} />
        <Route path="/heroes" element={<Heroes />} />
        <Route path="/heroes/:name" element={<Hero />} />
        <Route path="/updates" element={<Updates />} />
        <Route path="/updates/:url" element={<Update />} />
        <Route path="/matches/search" element={<MatchesSearch />} />
        <Route path="/matches/:id" element={<MatchPage />} />
      </Routes>
    </div>
    {renderPopup(popup)}
  </>
}

function renderPopup(popup: PopupType) {
  switch (popup) {
    case "present":
      return <PresentPopup type="buy" />
    case "dota_plus":
      return <BuyDotaPlusPopup />
    case "shards":
      return <BuyShardsPopup />
    case "payment_method":
      return <PaymentMethodPopup />
    case "payment_funpay":
      return <PaymentFunPayPopup />
    case "payment_patreon":
      return <PaymentPatreonPopup />
    case "present":
      return <PresentPopup type="buy" />
    case "present_history":
      return <PresentPopup type="history" />
    default:
      return null;
  }
}